import { render, staticRenderFns } from "./Dash-stories-feed-sort-panel.vue?vue&type=template&id=0b26433e"
import script from "./Dash-stories-feed-sort-panel.vue?vue&type=script&lang=js"
export * from "./Dash-stories-feed-sort-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports